export default __webpack_public_path__ + "static/media/verify.6e1c6cbc.svg";